const collections = [
  {
    title: '高分电影精选',
    desc: '豆瓣8.0+口碑佳作合集',
    count: '286部',
    icon: 'ri-star-line',
    color: 'accent',
  },
  {
    title: '本周热播推荐',
    desc: '实时热度飙升影片',
    count: '52部',
    icon: 'ri-fire-line',
    color: 'primary',
  },
  {
    title: '悬疑烧脑专场',
    desc: '反转不断的高能剧情',
    count: '148部',
    icon: 'ri-lightbulb-line',
    color: 'secondary',
  },
  {
    title: '动作冒险系列',
    desc: '肾上腺素飙升体验',
    count: '203部',
    icon: 'ri-flashlight-line',
    color: 'accent',
  },
  {
    title: '治愈温情影院',
    desc: '温暖心灵的感动故事',
    count: '119部',
    icon: 'ri-heart-line',
    color: 'primary',
  },
  {
    title: '科幻未来世界',
    desc: '脑洞大开的视觉盛宴',
    count: '167部',
    icon: 'ri-rocket-line',
    color: 'secondary',
  },
  {
    title: '国产原创力量',
    desc: '优秀华语影视作品',
    count: '312部',
    icon: 'ri-china-railway-line',
    color: 'accent',
  },
  {
    title: '经典永恒回顾',
    desc: '影史不朽名作重温',
    count: '178部',
    icon: 'ri-history-line',
    color: 'primary',
  },
  {
    title: '纪录片之旅',
    desc: '真实世界的精彩呈现',
    count: '95部',
    icon: 'ri-earth-line',
    color: 'secondary',
  },
];

export default function IndexSection() {
  const getColorClasses = (color: string) => {
    switch (color) {
      case 'accent':
        return { bg: 'bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-500' };
      case 'primary':
        return { bg: 'bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-500' };
      case 'secondary':
        return { bg: 'bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-500' };
      default:
        return { bg: 'bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-500' };
    }
  };

  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            精心策划的影视专题，按兴趣快速发现属于你的精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {collections.slice(0, 9).map((item) => {
            const cls = getColorClasses(item.color);
            return (
              <div
                key={item.title}
                className="bg-background-100 rounded-xl p-5 flex items-start gap-4 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group"
              >
                <div className={`w-12 h-12 rounded-xl ${cls.iconBg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} text-background-50 text-lg`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 mb-2">{item.desc}</p>
                  <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium ${cls.bg} ${cls.text}`}>
                    {item.count}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}